import { Link } from 'react-router-dom';
import { useCategories } from '@/hooks/useCategories';

export default function CategoryGrid() {
  const { getActiveCategories } = useCategories();
  const activeCats = getActiveCategories();

  if (activeCats.length === 0) return null;

  return (
    <section className="w-full bg-background-50 py-8 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading font-bold text-foreground-950 text-lg md:text-2xl mb-6 md:mb-8">
          Navegue por categorias
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {activeCats.map((cat, i) => (
            <Link
              key={cat.id}
              to={`/categoria/${cat.id}`}
              className="group cursor-pointer animate-fade-in-up"
              style={{ animationDelay: `${i * 60}ms`, animationFillMode: 'both' }}
            >
              <div className="bg-background-50 border border-background-200 rounded-xl p-3 md:p-6 flex flex-col items-center text-center transform transition-all duration-300 hover:-translate-y-1.5 hover:border-primary-300 hover:bg-primary-50/50">
                <div className="w-10 h-10 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100/60 group-hover:bg-primary-100 transition-colors mb-2 md:mb-3">
                  <i className={`${cat.icon} text-lg md:text-2xl text-primary-500 transition-transform duration-300 group-hover:scale-110`}></i>
                </div>
                <span className="font-bold text-foreground-950 text-xs md:text-sm mb-1 md:mb-1.5 group-hover:text-primary-700 transition-colors">
                  {cat.label}
                </span>
                <span className="text-primary-500 text-[10px] md:text-xs font-semibold inline-flex items-center gap-0.5 group-hover:gap-1.5 transition-all">
                  Ver artigos <i className="ri-arrow-right-line text-[10px] md:text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}